import React from 'react';

import type { Page } from '../../@types/ElasticSearchResponse';
import type { ElasticVehicle } from '../../@types/ElasticVehicle';
import GuaranteePackageHint from '../../routes/search/components/guarantee-package-hint';
import PaginationV2 from './pagination-v2';
import PlaceholderResultSet from './placeholder-result-set';
import ResultSet from './result-set';

interface SearchGridProps {
  isSearching: boolean;
  resultSet: ElasticVehicle[];
  pages: Page[] | null;
  target: string;
  onScrollTop?: () => void;
}

const SearchGrid = React.forwardRef(
  (
    { isSearching, resultSet, pages, target, onScrollTop }: SearchGridProps,
    ref: React.ForwardedRef<HTMLDivElement | null>,
  ) => {
    if (isSearching) {
      return (
        <section className="page-section">
          <PlaceholderResultSet size={12} />
        </section>
      );
    }

    return (
      <>
        <section className="page-section" ref={ref}>
          <ResultSet data={resultSet} title={'SOK'} />
        </section>
        {!!pages?.length && (
          <section className="page-section">
            <PaginationV2 pages={pages} target={target} onScrollTop={onScrollTop} />
          </section>
        )}
        <GuaranteePackageHint />
      </>
    );
  },
);

export default SearchGrid;
